import { useEffect, useMemo } from 'react';

type TFetchMissingItems<T, Key extends number | string = number> = {
  itemIds: Key[];
  itemMap: Record<Key, T>;
  fetchItemsFn: (ids: Key[]) => unknown;
};

const useFetchMissingItems = <T, Key extends number | string = number>({
  itemIds,
  itemMap,
  fetchItemsFn,
}: TFetchMissingItems<T, Key>) => {
  const [items, notFoundIds] = useMemo<[T[], Key[]]>(() => {
    const items: T[] = [];
    const notFoundIds: Key[] = [];
    itemIds.forEach((id) => {
      const item = itemMap[id];
      if (item) {
        items.push(item);
      } else {
        notFoundIds.push(id);
      }
    });
    return [items, notFoundIds];
  }, [itemIds, itemMap]);

  useEffect(() => {
    if (notFoundIds.length === 0) return;
    fetchItemsFn(notFoundIds);
  }, [notFoundIds, fetchItemsFn]);
  return items;
};

export default useFetchMissingItems;
